// assets/ajaxinate.js (or assets/ajaxinate.min.js - if minified)
"use strict";

var Ajaxinate = function(config) {
  var settings = config || {};
  var defaultSettings = {
    pagination: ".AjaxinatePagination",
    method: "scroll",
    container: ".AjaxinateLoop",
    offset: 0,
    loadingText: "Loading...",
    callback: null
  };

  this.settings = Object.assign(defaultSettings, settings);

  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);

  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.initialize();
};

Ajaxinate.prototype.initialize = function() {
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function() {
  if (this.paginationElement) {
    document.addEventListener("scroll", this.checkIfPaginationInView);
    window.addEventListener("resize", this.checkIfPaginationInView);
    window.addEventListener("orientationchange", this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.clickActive = true;
    if (this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function() {
  if (!this.paginationElement) return;

  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function() {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];

      if (newContainer) {
        this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML);
      }
      if (newPagination) {
        this.paginationElement.innerHTML = newPagination.innerHTML;
      }

      if (this.settings.callback && typeof this.settings.callback === "function") {
        this.settings.callback(this.request.responseXML);
      }
      this.initialize();
    }
  }.bind(this);
   // ADD THIS LOGIC
  // Get the current URL's query parameters
  const currentQueryParams = window.location.search;
  
  // Construct the new URL by combining the next page URL with the current query parameters
  let newUrl = this.nextPageUrl;
  if (currentQueryParams) {
    // Check if the next page URL already has query parameters
    if (newUrl.indexOf('?') === -1) {
      newUrl += currentQueryParams;
    } else {
      newUrl += '&' + currentQueryParams.substring(1);
    }
  }

  this.request.open("GET", newUrl); // Use the newUrl here
  this.request.responseType = "document";
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function() {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
  }
};

Ajaxinate.prototype.removeScrollListener = function() {
  document.removeEventListener("scroll", this.checkIfPaginationInView);
  window.removeEventListener("resize", this.checkIfPaginationInView);
  window.removeEventListener("orientationchange", this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function() {
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };
  if (destroyers[this.settings.method]) {
    destroyers[this.settings.method]();
  }
  return this;
};